<template>
  <router-view />
  <v-container  fluid class="fill-height back">
    <v-row class="rowlogin">
      <v-col class="d-flex justify-center logo">
        <v-img
            :src="require('../assets/newLogoApp.png')"

            contain
            height="150"
        />

      </v-col>
      <v-divider class="noneshow"/>
      <v-sheet class="mx-auto login" >
        <div id="login">
          <h5 class="text-center colorWhite title">شرکت بازرگانی یزدتکس</h5>
          <h6 class="text-center colorWhite">اوﻟﯿﻦ ﻣﺮﺟﻊ ﻓﺮوش آﻧﻼﯾﻦ پارچه مبلی</h6>
          <div class="form-group loginForm" style="">
            <span style="color: #fff; direction: ltr;position: absolute;left: 5px;font-size: 16pt;top:10px">+98 |</span>
            <input v-model="mobile" :maxlength="10" id="mobile" type="number" class="form-control" name="mobile" :readonly="showcode" @keyup.enter="login" style="background:none;border: none;direction: ltr;padding-left: 60px;color: #fff;font-size: 16pt">
            <div class="clearfix"></div>
          </div>
          <div v-if="showcode" class="form-group loginForm" style="">
            <span style="color: #fff; direction: rtl;position: absolute;right: 5px;font-size: 16pt;top:10px"> کد تایید|</span>
            <input v-model="code" @keyup.enter="login" type="number" :maxlength="6" class="form-control" name="code" style="background:none;border: none;direction: ltr;padding-right: 100px;color: #fff;font-size: 16pt">
            <div class="clearfix"></div>
          </div>
          <div class="form-group " style="width: 70%;margin: 10px auto 5px;background: #1fa29d;border-radius: 10px;position: relative;padding: 10px;font-size: 16pt;color: #fff;text-align: center" @click="login">
            <div class="float-right" style="width: 49%;border-left: 1px solid #fff">ورود</div>
            <div class="float-left" style="width: 49%">ثبت نام</div>
            <div class="clearfix"></div>
          </div>
          <div class="form-group" style="width: 70%;margin: 30px auto 5px;padding: 10px;font-size: 12pt;color: #fff;text-align: center;direction: ltr">
            (۰۲۱)۶۶۲۳۶۵۰۸
          </div>
          <p style="width: 70%;margin: 30px auto 5px;font-size: 10pt;color: #fff;text-align: center;border-top: 1px solid #616161;border-right: 1px solid #616161;padding: 5px">
            ﺗﻤﺎم ﺣﻘﻮق ﻣﺎدی و ﻣﻌﻨﻮی اﯾﻦ ﺑﺮﻧﺎﻣﻪ<br/>
            ﻣﺘﻌﻠﻖ ﺑﻪ ﺷﺮکﺖ یزدتکس می ﺑﺎﺷﺪ
          </p>
        </div>
      </v-sheet>
    </v-row>

  </v-container>
</template>

<script >
import http from "@/plugins/axios";
import {th} from "vuetify/locale";
import router from "@/router";
export default {
  name: 'login',

  data: () => ({
    islogin : false,
    mobile : "",
    showcode : false,
    code : "",
    password : "",
    auth : {
      token: "",
      user :{
        name : "",
        phone : "",
        profile : "",
      }
    }
  }),
  methods:{
    login(){
      if(this.showcode){
        const response =http.post("/check-login-sms",{
          phone : "0"+this.mobile,
          code : this.code,
        }).then(response => {
          this.auth.token = response.data.token;
          this.auth.user.name = response.data.user.name;
          this.auth.user.phone = response.data.user.phone;
          this.auth.user.profile = response.data.user.profile;
          localStorage.setItem("token",this.auth.token);
          localStorage.setItem("user_name",this.auth.user.name);
          localStorage.setItem("user_phone",this.auth.user.phone);
          localStorage.setItem("user_profile",this.auth.user.profile);
          this.$toast.success("با موفقیت وارد حساب کاربری خود شدید.")
          this.checkLogin();
        }).catch(error => {
          this.$toast.error("خطا در ورود به حساب کاربری")
        });
      }else{
        if (this.mobile!=""){
          const response =http.post("/login-sms",{
            phone : "0"+this.mobile,
          }).then(response => {
            this.$toast.success("لطفا کد تایید را وارد کنید");
            this.showcode=true;
          }).catch(error => {
            // console.log(error.response.data.errors);
            this.$toast.error(error.response.data.errors)
          });
        }else {
          this.$toast.error("شماره موبایل را وارد کنید")
        }

      }



    },
    checkLogin(){
      this.auth.token = localStorage.getItem("token");
      this.auth.user.name = localStorage.getItem("user_name");
      this.auth.user.phone = localStorage.getItem("user_phone");
      this.auth.user.profile = localStorage.getItem("user_profile");
      if(this.auth.token !=null){
        router.push("/home");
      }
    }
  },
  mounted() {
    this.checkLogin();
  },
}
</script>



<style scoped>
.loginForm{
  width: 70% !important;margin: 40px auto 5px;background: rgba(0,0,0,0.3);border-radius: 10px;position: relative
}
.title{
  font-size: 19pt;
  font-weight: 800;
}
.logo{
  margin-bottom: 100px;
}
.colorWhite{
  color: #fff;
}
.fill-height{
  width: 100%;
  max-width: 100%;
}
v-sheet{
  background: transparent;
}
.form-group{
  margin: 10px auto;
  width: 100%;
}
.form-group input{
  padding: 10px;
  width: 100%;
}
.form-group .label{
  margin: 10px 0;
}
button.btn{
  width: 400px;
  max-width: 90%;
  padding: 10px;
  margin: 10px auto;
}
.back{
  background-color: #e8e8e8;
  background-image: url('../assets/newlogin2.jpg');
  background-position: right center;
  background-repeat: no-repeat;
  background-size: cover;
}
#login{
  background: transparent;
}
#login .form-inputs {
  padding-bottom: 10px;
}

#login .form-inputs label {
  padding-right: 10px;
}
.loading{
  position: absolute;
  top: 65%;
  left: 49%;
}
.mx-auto{
  direction: rtl;
  background: transparent;
}
.v-field--center-affix .v-label.v-field-label{
  right: 0;
}
.noneshow{
  opacity: 0;
}
#login h3{
  margin: 20px auto;
}
.login{
  max-width: 100%;
  width: 500px;
  padding: 0 10px;
}
.rowlogin {
  width: 100%;
}
</style>